import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=2fc19e01&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"
import style0 from "./pagination.vue?vue&type=style&index=0&id=2fc19e01&prod&scoped=true&lang=scss"
import style1 from "./pagination.vue?vue&type=style&index=1&id=2fc19e01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc19e01",
  null
  
)

export default component.exports